module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAArBAMAAAD8sQfNAAAAAXNSR0IB2cksfwAAACpQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAChPOiAAAAA50Uk5TAFBvwP8gQH/fnzCA4KAhjhypAAAAPElEQVR4nGNggAMhBmzAJACraMKo6MCKipfDQMt0GKuIwcQFC2BYvRsGjtyGsTYOCl+MimKIYs1vCxFMAGCkNQGGhyqPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/plus@2x.png
// module id = 883
// module chunks = 0